import {
  AuthenticationCredentialsRequest,
  AuthenticationPasswordRequest,
  AuthenticationPasswordResetRequest,
  ChangeExpiredPasswordRequest,
  VerifyMfaOperationRequest,
} from '@openapi';
import { User } from '@services/types';
import { getAuthApi } from './configuration';

const auth = {
  login: (params: AuthenticationCredentialsRequest) => {
    return getAuthApi().authenticateByCredentials({ authenticationCredentialsRequest: params });
  },
  me: () => {
    return getAuthApi()
      .getMe()
      .then((me) => me as User);
  },
  reset: (params: AuthenticationPasswordResetRequest) => {
    return getAuthApi().createPasswordReset({ authenticationPasswordResetRequest: params });
  },
  resetExpiredPass: (requestParameters: ChangeExpiredPasswordRequest) => {
    return getAuthApi().changeExpiredPassword({ changeExpiredPasswordRequest: requestParameters });
  },
  newPass: (params: AuthenticationPasswordRequest) => {
    return getAuthApi().resetPassword({ authenticationPasswordRequest: params });
  },

  logOut: () => {
    return getAuthApi().unauthenticate();
  },
  verifyMfa: (params: VerifyMfaOperationRequest) => {
    return getAuthApi().verifyMfa(params);
  },
};

export default auth;
